import { render, staticRenderFns } from "./audit.vue?vue&type=template&id=4c5c5cc5&scoped=true&"
import script from "./audit.vue?vue&type=script&lang=js&"
export * from "./audit.vue?vue&type=script&lang=js&"
import style0 from "./audit.vue?vue&type=style&index=0&id=4c5c5cc5&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5c5cc5",
  null
  
)

export default component.exports